<script setup>
import { ref, onMounted, onBeforeMount, onBeforeUnmount, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router"; // Import useRouter for navigation

// Components
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import UpdateUserModal from "@/views/Users/UpdateUser.vue";
import UpdatePasswordModal from "@/views/Users/UpdatePassword.vue";
import generateUserProfile from "@/views/auth/domain/generate-user-profile"; // Import the function
const toggleDefaultLayout = () => store.commit("toggleDefaultLayout");

const token = sessionStorage.getItem("token"); // Assuming your token is stored with the key 'reset_token'

const router = useRouter(); // Initialize the router

// Estado de visibilidad de los modales
const showUserModal = ref(false);
const showPasswordModal = ref(false);
const store = useStore();

// Abre el modal correspondiente
const openModal = (type) => {
  if (type === "user") showUserModal.value = true;
  if (type === "password") showPasswordModal.value = true;
};

// Cierra todos los modales
const closeModal = () => {
  showUserModal.value = false;
  showPasswordModal.value = false;
};

const body = document.getElementsByTagName("body")[0];

// Estado de la información del perfil
const userProfile = ref({
  nombre: "",
  apellido: "",
  email: "",
  mobile: "",
  rol: "",
  organizacionNombre: "",
  organizacionCedulaJuridica: "",
  organizacionObjetivoSocial: "",
  organizacionRazonDeSer: "",
});

const loading = ref(true);
const error = ref(null);
/*
onBeforeMount(() => {
  store.state.layout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
  const userRole = sessionStorage.getItem("usuarioRol");
  if (userRole && userRole === 'administrador' || userRole === 'dueno') {
    store.state.showNavbar = true;
    store.state.showSidenav = true;

  } else if (userRole === 'usuario') {
    store.state.showNavbar = true;
    store.state.showSidenav = false;
  }
});*/

onMounted(async () => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip(store.state.bootstrap);

  await fetchUserProfile(); // Llamamos a la función para obtener la información del perfil
});
/*
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.layout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  const userRole = sessionStorage.getItem("usuarioRol");
  if (userRole) {
    toggleDefaultLayout();
    store.state.showNavbar = false;
  }
  body.classList.remove("profile-overview");
});*/

const fetchUserProfile = async () => {
  try {
    const data = await generateUserProfile();

    // Asignar la información del perfil al estado
    userProfile.value = {
      id: data.id_usuario, // Ensure this is available
      email: data.email,
      mobile: data.telefono || "No disponible",
      nombre: data.nombre_completo.split(" ")[0],
      apellido: data.nombre_completo.split(" ").slice(1).join(" "),
      rol: data.rol,
      junta: data.junta,
      provincia: data.distelec?.provincia || "No disponible",
      canton: data.distelec?.canton || "No disponible",
      distrito: data.distelec?.distrito || "No disponible",
    };

    loading.value = false;
  } catch (err) {
    error.value = "Hubo un problema al cargar el perfil del usuario.";
    loading.value = false;
  }
};
const isUsuario = computed(
  () => sessionStorage.getItem("usuarioRol") === "usuario"
);

const navigateToFormulario = () => {
  router.push({ path: "/inicio" }); // Navigate to the '/inicio' path
};
</script>

<template>
  <section>
    <div class="page-header min-vh-20 align-items-start pt-0 pb-10">
      <span class="mask bg-gradient-dark opacity-6"></span>
    </div>
    <!-- Mostrar error o cargando -->
    <div v-if="loading" class="text-center mt-4">
      <p>Cargando...</p>
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-danger text-center">{{ error }}</div>
    <div v-else>
      <!-- Tarjeta de perfil -->
      <div
        class="card shadow-lg mx-4 mt-3 mb-1 card-profile-bottom mt-lg-n5 mt-n6"
      >
        <div class="card shadow-lg">
          <div class="card-body p-3">
            <div class="row gx-4">
              <div class="col-auto">
                <div
                  class="avatar-xl position-relative d-flex align-items-center justify-content-center"
                >
                  <i class="fa fa-user fa-4x text-success"></i>
                </div>
              </div>
              <div class="col-auto my-auto">
                <div class="h-100">
                  <h5 class="mb-1">
                    {{ userProfile.nombre }} {{ userProfile.apellido }}
                  </h5>

                  <span>
                    {{
                      userProfile.rol === "administrador"
                        ? "Administrador"
                        : userProfile.rol === "dueno"
                        ? "Dueño"
                        : "Colaborador"
                    }}
                  </span>
                </div>
              </div>
              <!-- Botón para acciones de edición -->
              <div class="col-auto ms-auto d-flex">
                 <!--
                <div v-if="isUsuario" class="text-center">
                  <button
                    class="btn btn-sm btn-dark mb-0 me-3"
                    @click="navigateToFormulario"
                  >
                    <i class="fas fa-clipboard-list pe-2"></i> Volver al inicio
                  </button> 
                </div>-->
                <div class="dropdown-xs">
                  <button
                    class="btn btn-lg pt-1 pb-1 ps-3 pe-3 m-0 dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="fas fa-cog"></i>
                  </button>
                  <ul class="dropdown-menu w-20">
                    <li>
                      <a class="dropdown-item" @click="openModal('user')"
                        ><i class="fas fa-user-edit pe-1"></i> Editar
                        Informacion</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" @click="openModal('password')"
                        ><i class="fas fa-key pe-2"></i> Editar Contraseña</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid py-4">
        <div class="row">
          <!-- Tarjeta de Información de Perfil -->
          <div class="col-12 col-md-6 col-xl-6 mt-2 mt-md-0">
            <div class="card h-100 shadow-lg">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Información de Contacto</h6>
              </div>
              <div class="p-3 card-body">
                <ul class="list-group">
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong
                      class="text-xs text-uppercase text-body font-weight-bolder d-block"
                      ><i class="fas fa-phone-square-alt pe-2"></i>
                      Teléfono:</strong
                    >
                    <span>{{ userProfile.mobile }}</span>
                  </li>
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong
                      class="text-xs text-uppercase text-body font-weight-bolder d-block"
                      ><i class="fas fa-envelope pe-2"></i> Correo
                      Electrónico:</strong
                    >
                    <span>{{ userProfile.email }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Tarjeta de Información de la Organización -->
          <div class="col-12 col-md-6 col-xl-6 mt-4 mt-md-0">
            <div class="card h-100 shadow-lg">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Junta Asignada</h6>
              </div>

              <div class="p-3 card-body">
                <ul class="list-group">
                  <li class="pt-0 text-sm border-0 list-group-item ps-0">
                    <strong
                      class="text-xs text-uppercase text-body font-weight-bolder d-block"
                      ><i class="fas fa-city pe-2"></i> Provincia:</strong
                    >
                    <span>{{ userProfile.provincia }}</span>
                  </li>
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong
                      class="text-xs text-uppercase text-body font-weight-bolder d-block"
                    >
                      <i class="fas fa-building pe-2"></i> Canton:</strong
                    >
                    <span>{{ userProfile.canton }}</span>
                  </li>
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong
                      class="text-xs text-uppercase text-body font-weight-bolder d-block"
                      ><i class="fas fa-home pe-2"></i> Distrito:</strong
                    >
                    <span>{{ userProfile.distrito }}</span>
                  </li>
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong
                      class="text-xs text-uppercase text-body font-weight-bolder d-block"
                      ><i class="fas fa-school text-info pe-1"></i
                      ><i class="fas fa-flag text-danger pe-2"></i>Centro de
                      Votación:</strong
                    >
                    <span>{{ userProfile.junta }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modales -->
    <update-user-modal
      v-if="showUserModal"
      :id="userProfile.id"
      :name="`${userProfile.nombre} ${userProfile.apellido}`"
      :email="userProfile.email"
      :telefono="userProfile.mobile"
      :rol="userProfile.rol"
      :junta="userProfile.junta"
      :provincia="userProfile.provincia"
      :canton="userProfile.canton"
      :distrito="userProfile.distrito"
      @close="closeModal"
    />

    <update-password-modal
      v-if="showPasswordModal"
      :token="token"
      @close="closeModal"
    />
  </section>
</template>

<style scoped>
.profile-overview {
  background-color: #f8f9fa;
}

.card-profile-bottom {
  margin-top: -100px;
  border-radius: 15px;
}

.container-fluid {
  padding-top: 20px;
}

.card-body .col-md-4 {
  padding-left: 10px;
  padding-right: 10px;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
  margin: 2rem auto;
  color: #f0f4f8;
}

.card {
  min-height: 100px;
}

.page-header {
  background-image: url("@/assets/img/loginbg.jpg");
  background-size: unset;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
